export const commonAutomationIds = {
    IMAGELINK: 'at-image-link', // hero3, ImageBanner,
    IMAGE: 'at-responsive-component-image', // hero3, ImageBanner, imageHotSpot, StoryProduct,
    MAINTITLE: 'at-main-title', // hero, hero3, hero5, nucleus, shoppableImage, StoryProduct, StoryVideo, Timer, viznav,
    MAINSUBTITLE: 'at-main-subtitle', // hero, hero3, hero5, nucleus, shoppableImage, StoryProduct, StoryVideo, viznav,
    LEGALTEXT: 'at-legal-text', // hero, hero3, hero5, nucleus, Timer,
    LEGALLINK: 'at-legal-text-link', // hero, hero3, hero5, nucleus, Timer,
    MESSAGEGRAPHIC: 'at-message-graphic', // hero, StoryProduct, StoryVideo, StoryVideo,
    IMAGEGRAPHIC: 'at-image-graphic', // hero, StoryProduct, StoryVideo,
    MESSAGECONTAINER: 'at-messageLock', // hero, StoryProduct, StoryVideo,
};

export const heroAutomationIds = {
    EYEBROWTEXT: 'at-eyebrow-text', // hero,
    PRIMARYCONTAINER: 'at-hero-primary-container', // hero3, hero5,
    SECONDARYCONTAINER: 'at-hero-secondary-container', // hero3, hero5,
};

export const ctaAutomationIds = {
    LINK: 'at-cta-link', // hero, hero3, StoryProduct, StoryVideo,
    BUTTON: 'at-cta-button', // hero, hero3, nucleus, viznav,shoppableImage, StoryProduct, StoryVideo,
    DROPDOWN: 'at-cta-dropdown', // hero, hero3, StoryProduct, StoryVideo,
    DROPDOWNBTN: 'at-dropdown-button', // hero, hero3, StoryProduct, StoryVideo,
    DROPDOWNITEMS: 'at-dropdown-items', // hero, hero3, StoryProduct, StoryVideo,
    DROPDOWNLINK: 'at-dropdown-link', // hero, hero3, StoryProduct, StoryVideo,
};

export const bannerAutomationIds = {
    BANNER: 'at-banner', // hero3, nucleus, viznav,
    LINK: 'at-banner-link', // hero5, nucleus, viznav,
    IMAGE: 'at-banner-image', // hero3, hero5, nucleus, viznav,
    TITLE: 'at-banner-title', // hero3, nucleus,
    SUBTITLE: 'at-banner-subtitle', // hero3, nucleus,
    CTATEXT: 'at-banner-cta-text', // hero5, viznav,
    CAROUSEL: 'at-carousel-items', // nucleus, viznav,
    BANNERSSECTION: 'at-banners-section', // nucleus, viznav,
};

export const hero3BannerAutomationIds = {
    IMAGELINK: 'at-banner-image-link', // hero3,
    CTALINK: 'at-banner-cta-link', // hero3,
    BUTTON: 'at-banner-cta-button', // hero3,
    DROPDOWN: 'at-banner-cta-dropdown', // hero3,
    DROPDOWNBTN: 'at-banner-dropdown-button', // hero3,
    DROPDOWNITEMS: 'at-banner-dropdown-items', // hero3,
    DROPDOWNLINK: 'at-banner-dropdown-link', // hero3,
    LEGALTEXT: 'at-banner-legal-text', // hero3,
    LEGALLINK: 'at-banner-legal-text-link', // hero3,
};
